<template>
  <div class="shop_home_banner">
  </div>
</template>

<script>
  import banner from "@/assets/img/supermarker/banner2.png"
  export default {
    props:{
      info: {
        type: Object,
        default: null
      }
    },
    computed:{
      shopInfo(){
        return this.$store.state.shopInfo;
      }
    },
    data() {
      return {
        banner: banner
      }
    }
  }
</script>

<style lang="scss">
.shop_home_banner{
  height: 400px;
  background:#fde0b8  url(~@/assets/img/supermarker/banner2.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
}
</style>